module.exports = __webpack_public_path__ + "img/chevron-left.a1b271c8.svg";